<template>
  <div class="outbound-history-page">
    <div
      v-for="item in resultList"
      :key="item.id"
      class="order-item"
      @click="onclickSelectItem(item)"
    >
      <div class="info">
        <div class="name">
          {{ item.factoryName }}{{ item.deviceCountList[0].deviceTypeName }}x{{
            item.outboundCount
          }}
        </div>
        <div class="time">{{ item.time | formateTime }}</div>
      </div>
      <div class="state">
        <div class="status">
            <template v-if="item.factoryConfirmedStatus == 0"
                >待确认</template
            >
        </div>
        <Icon name="arrow" class="item-arrow" />
      </div>
    </div>
    <Button type="default" v-if="!isShowAll" @click="loadMore"
      >点击加载更多</Button
    >
  </div>
</template>

<script>
import { Icon, Button } from "vant";
import { formateTime } from '@/utils/time'
export default {
    name: "OutBoundList",
    components: {
        Icon,
        Button
    },
    filters: {
        formateTime
    },
    data() {
        return {
            // 分页
            pageNo: 1,
            pageSize: 10,
            resultList: [],
            isShowAll: false,
        }
    },
    created() {
        this.getOutbound();
    },
    methods: {
        // 获取库房出库记录
        getOutbound() {
            const vm = this;
            const uuid = vm.$route.query.uuid || vm.$localStorage.getItem('uuid');
            const fType = vm.$strTool.filterFactoryType(uuid);
            const factoryType = vm.getOutboundFactoryType(fType);
            vm.$http({
                type: "get",
                url: `${vm.$config.base.MP_WECHAT_BASE_URL}erpFactory/getOutbound`,
                params: {
                    password: vm.$config.base.wechatPassword,
                    factoryType,
                    pageSize: vm.pageSize,
                    pageNo: vm.pageNo
                }
            }).then((res) => {
                const records = res.data.records;
                if (vm.pageNo === 1) {
                    vm.resultList = [];
                }
                vm.resultList = vm.resultList.concat(records);
                
                if (records.length < vm.pageSize) {
                    vm.isShowAll = true;
                } else {
                    vm.isShowAll = false;
                }
            })
        },

        onclickSelectItem(item) {
            this.$router.push({
                name: "OutBoundInfo",
                params: {
                    item: item
                }
            })
        },

        trackNumBtn(id) {
            this.$emit('track-num', id);
        },
        
        // 获取库房出库对应类型
        getOutboundFactoryType(type) {
            const factory = {
                'ruiyin': 2,
                'wangbo': 3,
                'haopai': 6
            }
            return factory[type] || 0;
        },

        // 点击加载更多
        loadMore() {
            const vm = this;
            vm.pageNo++;
            vm.getOutbound();
        },
    },

    
}
</script>

<style lang="less" scoped>
.outbound-history-page {
  background: #f6f9fa;
  height: 100%;
  .order-item {
    height: 0.8rem;
    width: 100%;
    padding: 0.1rem 0.15rem;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.18rem;

    .info {
      .name {
        color: #333333;
      }
      .time {
        margin-top: 0.1rem;
        color: #555555;
      }
    }

    .state {
      display: flex;
      align-items: center;
      color: #333333;

      .btn {
        width: 1rem;
        height: 0.4rem;
        background: #209a56;
        border-radius: 0.2rem;
        text-align: center;
        line-height: 0.4rem;
        color: #ffffff;
      }

      .arrow-icon {
        margin-left: 0.1rem;
      }

      .status {
        color: #FF7C00;
        margin-right: 0.1rem;
      }
    }

    
  }
  .van-button {
    border: 0;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>